import { jsxs as l, jsx as i } from "react/jsx-runtime";
import { Stack as p, CircularProgress as o, circularProgressClasses as t } from "@mui/material";
const n = 4, $ = ({ value: e = void 0, size: r, label: s }) => /* @__PURE__ */ l(p, { sx: { position: "relative" }, children: [
  /* @__PURE__ */ i(
    o,
    {
      variant: "determinate",
      sx: (a) => ({
        [`& .${t.svg}`]: {
          width: `${r}px !important`,
          height: `${r}px !important`
        },
        [`& .${t.circle}`]: {
          color: `${a.palette.grey[100]} !important`
        }
      }),
      size: r,
      thickness: n,
      value: 100,
      role: "none",
      "aria-valuenow": null
    }
  ),
  /* @__PURE__ */ i(
    o,
    {
      variant: e ? "determinate" : "indeterminate",
      disableShrink: !0,
      sx: (a) => ({
        position: "absolute",
        left: 0,
        [`& .${t.svg}`]: {
          width: `${r}px !important`,
          height: `${r}px !important`
        },
        [`& .${t.circle}`]: {
          strokeLinecap: "round",
          color: `${a.palette.primary[600]} !important`
        }
      }),
      size: r,
      thickness: n,
      value: e,
      "aria-label": s
    }
  )
] });
export {
  $ as C
};
